import { SkeletonText } from './skeleton-text';
import { SkeletonMedia } from './skeleton-media';
import { SkeletonCircle } from './skeleton-circle';

export { SkeletonText as Skeleton, SkeletonMedia, SkeletonCircle };
